<template>
  <file-uploader class="p-5" :value="files" :audio="audio" @input="onFileInput" :maxFileCount="32" />
</template>

<script>
import FileUploader from "shared/widgets/upload/FileUploader.vue";

export default {
  name: "FileBlock",
  components: { FileUploader },
  props: {
    value: null,
    audio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: this.value,
    };
  },
  methods: {
    onFileInput(values) {
      this.$emit(
        "input",
        values.filter((f) => typeof f.id !== "string")
      );
      this.$emit("update");
    },
  },
};
</script>
